export const USERS = {
    SET_USER_LIST: 'USERS.SET_USER_LIST',
    SET_USER_EXCHANGE_DIALOG_VISIBILITY:'USERS.SET_USER_EXCHANGE_DIALOG_VISIBILITY',
}